import React, { createContext, useContext, useState } from "react";

// Create the context
const WorkOrdersContext = createContext();

// Provider component
export const WorkOrdersContextProvider = ({ children }) => {
  const [ids, setIds] = useState(new Set());
  const [selectedAll, setSelectedAll] = useState(false);

  const onSelect = (id) => {
    setIds((prev) => {
      const newSet = new Set(prev);
      newSet.has(id) ? newSet.delete(id) : newSet.add(id);
      return newSet;
    });
  };

  const onSelectAll = (ids, val) => {
    setIds(ids);
    setSelectedAll(val);
  };

  const onClear = () => {
    setIds(new Set());
    setSelectedAll(false);
  };

  const count = ids.size;
  const getIds = () => Array.from(ids);

  return (
    <WorkOrdersContext.Provider
      value={{
        ids,
        getIds,
        onSelect,
        count,
        onClear,
        selectedAll,
        onSelectAll,
        onSelect,
      }}
    >
      {children}
    </WorkOrdersContext.Provider>
  );
};

// Hook to use the context
export const useWorkOrdersContext = () => {
  const context = useContext(WorkOrdersContext);
  if (!context) {
    throw new Error(
      "useWorkOrdersContext must be used within a WorkOrdersContextProvider"
    );
  }
  return context;
};
